export default {
  PREFIX_CALLBACKS: ['service', 'callback', 'redirect'],
  CRM_COOKIE: 'CRM_TRACKING',
  DISABLE_REQUESTS_ACTION: {
    // dashboard
    '/dashboard/users/info': [{ redirect: false, notify: false, status: 'all' }],
  },
};
